// extracted by mini-css-extract-plugin
export default {"container":"IngredientItem_container__1tl7V","counter":"IngredientItem_counter__YsCch","title":"IngredientItem_title__Tg7FM","dragging":"IngredientItem_dragging__5isT4"};